module.exports = __webpack_public_path__ + "img/js.307290cb.svg";